import {callApi} from '@/api/apibase'

export const createOrder = function (locationId, productId, greenCourseId, isCourseExtension, customersCourseId) {
    console.log('createOrder.js', locationId, productId, greenCourseId, isCourseExtension, customersCourseId)
    const requestData = {
        locationId: locationId,
        productId: productId,
        greenCourseId: greenCourseId,
        IsCourseExtension: isCourseExtension,
        customersCourseId: customersCourseId
    }
    return callApi( 'POST','/api/shop/externalsystem/order/createFromExternalGreenCoursePortal', requestData)
}

